import { Component, OnInit ,ViewChild} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CucurachaAdminService } from '../service/cucuracha.service';

@Component({
  selector: 'app-exportlogs',
  templateUrl: './exportlogs.component.html',
  styleUrls: ['./exportlogs.component.css']
})
export class ExportLogsComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: any;
  displayedColumns = ['adminId', 'moduleName','dateTime']
  constructor(private cs:CucurachaAdminService) { }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  getAllExportLogs(){
    this.cs.getExportLogs().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data)
  this.dataSource.sort = this.sort
  this.dataSource.paginator = this.paginator
    })
  }
  ngOnInit(): void {
    this.getAllExportLogs();
  }

}
